export const socialLoginRedirect = (provider) => {
  const url = `${import.meta.env.VITE_API_BASE_URL}/auth/${provider}-sign-in`;
  window.location.assign(url);
};
